<connect-header max-width="2560" [flags]="this.flags"></connect-header>
<div class="toaster">
  <app-toaster></app-toaster>
</div>
<app-header [menu]="this.menus"></app-header>
<div class="wrapper-class" [ngClass]="(currenturl != '/home' && currenturl != '/')?'wrapper-padding-color':''">
  <router-outlet></router-outlet>
</div>
<input type="text" name="xbcSession" id="xbcSession" style="display: none;">
<connect-footer max-width="2560"></connect-footer>
